namespace Matrix.Data {
    export interface SecurityRelationshipForm {
        SecurityId: Serenity.IntegerEditor;
        RelationshipTypeCode: FormatLookupEditor;
        RelatedSecurityId: FormatLookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityRelationshipForm extends Serenity.PrefixedContext {
        static formKey = 'Matrix.Data.Forms.SecurityRelationshipForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityRelationshipForm.init)  {
                SecurityRelationshipForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = FormatLookupEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(SecurityRelationshipForm, [
                    'SecurityId', w0,
                    'RelationshipTypeCode', w1,
                    'RelatedSecurityId', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
